/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-creative-dims-output',
  template: `
    <div *ngIf="creative?.dimensionType === 'FIXED'">
      <span *ngIf="!creative?.width && !creative?.height">-</span>
      <span *ngIf="creative?.width || creative?.height">{{ creative?.width || '--' }}&times;{{ creative?.height || '--' }}</span>
    </div>
    <div *ngIf="creative?.dimensionType === 'FIXED_WIDTH'">
      {{ creative?.width || '--' }}px width
    </div>
    <div *ngIf="creative?.dimensionType === 'FIXED_HEIGHT'">
      {{ creative?.height || '--' }}px height
    </div>
    <div *ngIf="creative?.dimensionType === 'FLEXIBLE'">
      Flexible
    </div>
  `
})
export class CreativeDimsOutputComponent {
  @Input() creative: any;
}
